
window.ECV_CONFIGURATION='INGBANK';
console.log("ECV CONFIGURATION = INGBANK");
let modules = [
import('../modules/CoreModules/Demo'),
import('../modules/CoreModules/PureWebRTC'),
import('../modules/CoreModules/ExternalAdapter'),
import('../modules/CoreModules/Photo'),
import('../modules/CustomerModules/INGBank/Glif'),
import('../modules/CoreModules/RemoteFlashTrigger'),
import('../modules/CoreModules/BgBlur'),];
export default modules;